import './slide.css'


function Slide({
    children,
    show,
    direction = "down"
}) {

    return (
        <div className={`slide-grid-${direction} ${show ? `slide-grid-${direction}-active` : ''}`}>
            <div className="slide-grid-content">
                {children}
            </div>
        </div>
    );
}

export default Slide; 
